// styles
import styled from "styled-components";

const RowStyles = styled.div`
  background: ${({ theme }) => theme.colors.semantic.container.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  padding: 17px ${({ theme }) => theme.spacing[24]};
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
`;

const Row = ({ onClick, children, style, className }) => {
  return (
    <RowStyles onClick={onClick} style={{ ...style }} className={className}>
      {children}
    </RowStyles>
  );
};

export default Row;
